var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"errorMessage":_vm.errorMessage,"successMessage":_vm.successMessage},on:{"errorMessageClosed":function($event){_vm.errorMessage = ''}}},[_c('UploadedReports')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }